import { Stack, Text, Select, Paper } from '@mantine/core';

const PA_CATEGORIES = [
  { value: 'A', label: 'Category A — Debris Removal', description: 'Clearance of trees, woody debris, sand, mud, silt, gravel, building wreckage' },
  { value: 'B', label: 'Category B — Emergency Protective Measures', description: 'Actions taken before, during, and after a disaster to save lives and protect property' },
  { value: 'C', label: 'Category C — Roads & Bridges', description: 'Repair of roads, bridges, and associated features such as shoulders, ditches, culverts, lighting' },
  { value: 'D', label: 'Category D — Water Control Facilities', description: 'Repair of drainage channels, pumping facilities, dams, levees' },
  { value: 'E', label: 'Category E — Public Buildings & Contents', description: 'Repair or replacement of buildings, supplies, inventory, vehicles, equipment' },
  { value: 'F', label: 'Category F — Public Utilities', description: 'Repair of water treatment plants, power generation, sewage, communications' },
  { value: 'G', label: 'Category G — Parks, Recreational & Other', description: 'Repair of parks, playgrounds, mass transit facilities, beaches' },
];

interface Props {
  value: string;
  onChange: (val: string | null) => void;
}

export default function PACategorySelector({ value, onChange }: Props) {
  const selected = PA_CATEGORIES.find(c => c.value === value);

  return (
    <Stack gap="xs">
      <Text fw={500} size="sm">FEMA PA Category</Text>
      <Select
        value={value || null}
        onChange={onChange}
        data={PA_CATEGORIES.map(c => ({ value: c.value, label: c.label }))}
        placeholder="Select PA Category"
        searchable
        size="md"
      />
      {selected && (
        <Paper withBorder p="xs" radius="sm">
          <Text size="xs" c="dimmed">{selected.description}</Text>
        </Paper>
      )}
    </Stack>
  );
}
